import { AxiosResponse } from "axios";

import { axiosInstance, MessageResponse } from "./common";

export enum BranchCategory {
  METRO = "METRO",
  URBAN = "URBAN",
  SEMI_URBAN = "SEMI_URBAN",
  RURAL = "RURAL",
}

export enum BranchSize {
  SMALL = "SMALL",
  MEDIUM = "MEDIUM",
  LARGE = "LARGE",
}

export const BRANCH_CATEGORY_LABELS: Record<BranchCategory, string> = {
  [BranchCategory.METRO]: "Metro",
  [BranchCategory.URBAN]: "Urban",
  [BranchCategory.SEMI_URBAN]: "Semi Urban",
  [BranchCategory.RURAL]: "Rural",
};

export const BRANCH_SIZE_LABELS: Record<BranchSize, string> = {
  [BranchSize.SMALL]: "Small",
  [BranchSize.MEDIUM]: "Medium",
  [BranchSize.LARGE]: "Large",
};

export interface BranchDetails {
  branch_id: string;
  zonal_office?: string;
  name?: string;
  sol_id?: string;
  category?: BranchCategory;
  size?: BranchSize;
  address?: string;
}

export interface GetBranchDetailsResponse {
  branch_details: BranchDetails[];
}

export interface UpsertBranchDetailsRequest extends BranchDetails {}

export const BranchDetailsAPI = {
  get: async (branch_ids: string[]): Promise<GetBranchDetailsResponse> => {
    const response: AxiosResponse<GetBranchDetailsResponse> =
      await axiosInstance.get("/v1/branch-details", {
        params: {
          branch_ids,
        },
        paramsSerializer: {
          indexes: null,
        },
      });

    return response.data;
  },

  upsert: async (
    request: UpsertBranchDetailsRequest,
  ): Promise<MessageResponse> => {
    const response: AxiosResponse<MessageResponse> = await axiosInstance.put(
      "/v1/branch-details",
      request,
    );

    return response.data;
  },
};